import moment from 'moment';

export const serviceLevels = {
	free: 'FREE',
	ssScoreboard: 'SS SCOREBOARD',
	nonBranded: 'NON BRANDED SCOREBOARD',
	api: 'API/TICKER',
};

export const billingStatuses = {
	limited: 'LIMITED',
	cancelled: 'CANCELLED',
	none: 'NONE',
	current: 'CURRENT',
	comped: 'COMPED',
	gracePeriod: 'GRACE PERIOD',
	late: 'LATE',
};

function isCrossOriginFrame () {
	try {
		//should trigger an error if you're not on the same domain due to same-origin policy
		const canAccessTop = window.top.location.hostname;
		if (!canAccessTop) { return true; }
		//we're trying embedding widgets in iframes w/ no src attr
		//for these widgets, we'll still be able to access the parent document
		//in this case we'll try to access the analytics frame
		const analyticsFrame =  parent.document
			.getElementsByClassName(trackingFrameClassName)[0];
		if (!analyticsFrame) {
			return false;
		} else {
			return !analyticsFrame.contentDocument;
		}
	} catch (e) {
		return true;
	}
}

const validServiceLevels = [
	serviceLevels.ssScoreboard,
	serviceLevels.nonBranded,
	serviceLevels.api,
];

export function canShowCustomAds (userWidgetData) {
	const isLocal = !isCrossOriginFrame();
	//if we're not in a cross origin iframe, then we should be in a local page (e.g. widgetCreator)
	if (isLocal) { return true; }

	const hasPremiumWidgetsFromMup = (validServiceLevels.includes(userWidgetData.serviceLevel) && billingStatuses.cancelled !== userWidgetData.billingStatus);

	//if mup says their status is bad, use that. If mup don't know, check if a widget owner is a premium customer (hasPremiumWidgets is set in the fetch routine)
	const now = moment.utc().format('YYYY-MM-DD HH:mm:ss');
	const hasPremiumWidgets = userWidgetData.hasPremiumWidgetsUntil &&
		userWidgetData.hasPremiumWidgetsUntil > now;
	return hasPremiumWidgetsFromMup ||
		(userWidgetData.billingStatus === billingStatuses.none && hasPremiumWidgets) ||
		(!userWidgetData.serviceLevel && hasPremiumWidgets);
}

//the className that gets used here is actually important, and should not be changed -- the widget code (realtime/widgets, and the canShowCustomAds method in this module) uses the className when testing if it's in a cross origin frame
//it's a bit of a hack, but I wanted a synchronous way to check
export const trackingFrameClassName = 'scorestreamNewWidget';
